<p [ngClass]="{'doc-body-2': boldLabel}" [innerHTML]="label"></p>
<mat-hint>
    <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
</mat-hint>
<!-- <ng-container *ngFor="let option of options">
    <mat-checkbox class="doc-custom-checkbox w-100 d-block" [value]="getValue(option)" [checked]="isChecked(option)"
        (change)="changedStatus($event)">
        <span class="label">
            {{getName(option)}}
        </span>
    </mat-checkbox>
</ng-container> -->
<mat-checkbox class="doc-custom-checkbox w-100" *ngIf="addOtherOption" [checked]="acceptOther"
    (change)="otherOptionStatus($event)">
    <span class="label">
        Others
    </span>
</mat-checkbox>

<div *ngIf="acceptOther">
    <mat-form-field appearance="outline" floatLable="never" class="w-100 mb-3 doc-custom-input">
        <textarea matInput [placeholder]="placeholder" autocomplete="off" [value]="otherValue" [disabled]="disabled"
            (input)="otherOption($event.target.value)" (blur)="touched()" [cdkTextareaAutosize]="autoResize"
            [cdkAutosizeMinRows]='maxRows' [cdkAutosizeMaxRows]='minRows' #inputEl>
        </textarea>

        <mat-hint>
            <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
        </mat-hint>

    </mat-form-field>
</div>